import { render, staticRenderFns } from "./TabDatosDelegado.vue?vue&type=template&id=bbd9f7ee"
import script from "./TabDatosDelegado.vue?vue&type=script&lang=js"
export * from "./TabDatosDelegado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbd9f7ee')) {
      api.createRecord('bbd9f7ee', component.options)
    } else {
      api.reload('bbd9f7ee', component.options)
    }
    module.hot.accept("./TabDatosDelegado.vue?vue&type=template&id=bbd9f7ee", function () {
      api.rerender('bbd9f7ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabDatosDelegado.vue"
export default component.exports